import React, { Component } from "react";
import { withRouter, NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { get } from "../../../../../utils/request";
import "./style.css";
class SubjectRankKeySearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickName: "取消",
      name: "",
      majors: [],
      chang: false,
    };
  }
  componentDidMount() {
    this.textInput.focus();
  }
  render() {
    const { placeholder } = this.props;
    const { majors, chang } = this.state;
    return (
      <div className="subjectRankKeySearch_box">
        <div className="subjectRankKeySearch_box_left fl">
          <div className="subjectRankKeySearch_box_left_div">
            <div className="subjectRankKeySearch_box_left_div_img fl">
              <img
                alt=""
                src={require("../../../../../images/search/search_2.png")}
              ></img>
            </div>
            <div className="subjectRankKeySearch_box_left_div_input fl">
              <input
                value={this.state.name}
                onChange={this.handleChang}
                ref={(input) => {
                  this.textInput = input;
                }}
                placeholder={placeholder}
              ></input>
            </div>
            <div
              style={{
                display: this.state.name !== "" ? "block" : "none",
              }}
              className="subjectRankKeySearch_box_right_div_img fr"
              onClick={() => this.handleRemoveName()}
            >
              <img
                alt=""
                src={require("../../../../../images/search/search_3.png")}
              ></img>
            </div>
          </div>
        </div>
        <div className="subjectRankKeySearch_box_right fl">
          <div
            onClick={this.handleCancle}
            className="subjectRankKeySearch_box_right_txt fl"
          >
            {this.state.clickName}
          </div>
        </div>
        <div className="clear"></div>
        <div className="subjectRankKeySearch_box_item">
          {chang === true && majors.length === 0 ? (
            <NavLink
              style={{ color: "#fb6620" }}
              to={"/rank/subject/search"}
              className="subjectRankKeySearch_item"
            >
              这里为学科排名，未发现相关学科排名
            </NavLink>
          ) : (
            ""
          )}
          {majors.map((item, index) => {
            return (
              <NavLink
                to={"/rank/subject/intro/" + item.hashId}
                key={index}
                className="subjectRankKeySearch_item"
              >
                {item.name}
              </NavLink>
            );
          })}
        </div>
      </div>
    );
  }
  /**
   * 取消
   */
  handleCancle = () => {
    this.setState({
      name: "",
      majors: [],
      chang: false,
    });
    this.props.history.push("/rank/subject");
  };

  /**
   * input输入框变化的时候
   */
  handleChang = (e) => {
    this.setState({
      name: e.target.value,
    });
    if (e.target.value.length > 0) {
      get("/public/v1/rank/subject/subclass/search/" + e.target.value).then((res) => {
        this.setState({
          majors: res.data,
          chang: true,
        });
      });
    } else {
      this.setState({
        majors: [],
        chang: false,
      });
    }
  };
  /**
   * 移除搜索的院校名称
   */
  handleRemoveName = () => {
    this.setState({
      name: "",
      majors: [],
      chang: false,
    });
  };
}

export default connect()(withRouter(SubjectRankKeySearch));



// WEBPACK FOOTER //
// ./src/containers/Rank/SubjectRank/components/SubjectRankKeySearch/index.js